"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiKeyHelper = require("./../../helpers/api-key-helper");

var _gtmEventHelper = require("../helpers/gtm-event-helper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Google Tag Manager Logger, includes javascript from tag manager, and starts logging when its loaded
 * these methodes will be called by the analytics service!
 *
 * @class GoogleTagManagerLogger
 */
var GoogleTagManagerLogger = /*#__PURE__*/function () {
  function GoogleTagManagerLogger() {
    (0, _classCallCheck2["default"])(this, GoogleTagManagerLogger);
  }

  (0, _createClass2["default"])(GoogleTagManagerLogger, [{
    key: "init",
    value:
    /**
     * called by Analytics service when its ready to send analytics
     *
     *
     * @memberOf GoogleTagManagerLogger
     */
    function init() {
      var apiKey = (0, _apiKeyHelper.getApiKey)('google_tag_manager');

      if (!this.isInitialized && apiKey != null) {
        this.isInitialized = true;
        this.includeJs(apiKey);
      }
    }
  }, {
    key: "includeJs",
    value: function includeJs(apiKey) {
      // eslint-disable-next-line no-sequences, no-undef, no-sequences, one-var
      ;

      (function (w, d, s, l) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        }); // eslint-disable-next-line no-sequences, no-undef, no-sequences, one-var

        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + apiKey + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer');
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "login",
    value: function login(name, email, accountId, globalIdentity) {
      if (this.isInitialized) {
        this.accountId = accountId;
        this.globalIdentity = globalIdentity;
        this.impactRadiusCampaignId = (0, _apiKeyHelper.getApiKey)('impact_radius_campaign_id');
        window.dataLayer.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _gtmEventHelper.GetGtmSessionAttributes)()), (0, _gtmEventHelper.GetGtmPageAttributes)()), (0, _gtmEventHelper.GetGtmVpvAttributesFromActivePage)()), {}, {
          event: 'UserLoggedIn',
          userid: this.globalIdentity,
          accountId: this.accountId,
          impactRadiusCampaignId: this.impactRadiusCampaignId
        }));
      }
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "logout",
    value: function logout() {}
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackPageView",
    value: function trackPageView(path) {
      if (this.isInitialized) {
        window.dataLayer.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          event: 'virtualPageView'
        }, (0, _gtmEventHelper.GetGtmSessionAttributes)()), (0, _gtmEventHelper.GetGtmPageAttributes)()), (0, _gtmEventHelper.GetGtmVpvAttributesFromActivePage)()), {}, {
          vpvStep: path,
          // override vpv step, because trackPageView event could be triggered manually
          page: {
            title: document.title,
            url: path
          },
          userid: this.globalIdentity,
          accountId: this.accountId
        }));
      }
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackUserDomains",
    value: function trackUserDomains(domainCountObject) {
      if (this.isInitialized) {
        window.dataLayer.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          event: 'trackUserDomains'
        }, (0, _gtmEventHelper.GetGtmSessionAttributes)()), (0, _gtmEventHelper.GetGtmPageAttributes)()), (0, _gtmEventHelper.GetGtmVpvAttributesFromActivePage)()), {}, {
          page: _objectSpread({}, domainCountObject),
          userid: this.globalIdentity,
          accountId: this.accountId
        }));
      }
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackEvent",
    value: function trackEvent(action, obj) {
      if (this.isInitialized) {
        if (action === 'AccountJoined') {
          obj.impactRadiusActionId = (0, _apiKeyHelper.getApiKey)('impact_radius_lead_action_id');
        }

        window.dataLayer.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _gtmEventHelper.GetGtmSessionAttributes)()), (0, _gtmEventHelper.GetGtmPageAttributes)()), (0, _gtmEventHelper.GetGtmVpvAttributesFromActivePage)()), obj), {}, {
          event: 'trackEvent',
          action: action
        }));
      }
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackEcommercePurchase",
    value: function trackEcommercePurchase(orderId, totalPriceExTax, totalTax, status, products) {
      if (this.isInitialized) {
        window.dataLayer.push({
          event: 'trackEcommercePurchase',
          ecommerce: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _gtmEventHelper.GetGtmSessionAttributes)()), (0, _gtmEventHelper.GetGtmPageAttributes)()), (0, _gtmEventHelper.GetGtmVpvAttributesFromActivePage)()), (0, _gtmEventHelper.GetGtmProductsFromObj)(products)), {}, {
            order_id: orderId,
            order_grand_total: totalPriceExTax,
            order_tax_amount: totalTax,
            order_shipping_amount: null,
            order_promo_code: null,
            affiliation: null
          })
        });
      }
    }
  }]);
  return GoogleTagManagerLogger;
}();

var _default = new GoogleTagManagerLogger();

exports["default"] = _default;